import React from 'react'
import { InsightContentSettingType } from 'components/insightContent/types'
import { CountTypeStrings } from 'enums/CountType'

import SingleMeasure from '../SingleMeasure'
import Title from './Title'

const NameMeasure = ({
  detailSetting,
  countType,
  renderTitleContent,
  forceNotScale
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  renderTitleContent?: () => React.ReactNode
  forceNotScale?: boolean
}) => {
  const { selectionName } = detailSetting

  return (
    <SingleMeasure
      detailSetting={detailSetting}
      countType={countType}
      forceNotScale={forceNotScale}>
      <Title
        countType={countType}
        selectionName={selectionName}
        renderContent={renderTitleContent}
      />
    </SingleMeasure>
  )
}

export default NameMeasure
